import { DonutChart } from '@mantine/charts';

import { getSeriesColor } from '#core/lib/formatters/colors.ts';
import { makeFieldFormatter } from '#core/lib/formatters/number-decimals.ts';

import type { ChartRendererProps } from '../types.ts';

/**
 * Converts generic data to donut format {name, value, color}.
 */
function toDonutData(
  data: Record<string, unknown>[],
  xAxis: string,
  yAxis: string,
): { name: string; value: number; color: string }[] {
  return data.map((row, i) => ({
    name: String(row[xAxis] ?? `Item ${i + 1}`),
    value: typeof row[yAxis] === 'number' ? row[yAxis] : 0,
    color: getSeriesColor(i),
  }));
}

/**
 * Renders donut chart.
 */
export function DonutChartRenderer({ config, width, height }: ChartRendererProps) {
  const donutData = toDonutData(config.data, config.xAxis, config.yAxis);
  const size = Math.min(width, height) * 0.5;

  return (
    <DonutChart
      data={donutData}
      size={size}
      thickness={20}
      valueFormatter={makeFieldFormatter(config.data, config.yAxis)}
      withLabels
      withTooltip
    />
  );
}
